import { render } from "./TissGuides.vue?vue&type=template&id=f4912a9e"
import script from "./TissGuides.vue?vue&type=script&lang=js"
export * from "./TissGuides.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__